import { isEmpty } from "lodash-es";
/*
  Authenticated oAuth2 token request variables. These are not secret values, but
  vary by environment.
*/
export const AUTH_ENABLED = isEmpty(process.env.REACT_APP_AUTH_ENABLED)
  ? true
  : process.env.REACT_APP_AUTH_ENABLED?.toLowerCase() === "true";

// This scope is only used to ensure that our Frontend app gets a token with the
// correct audience. Without any scopes, MSAL will return a token whose audience
// is Microsoft Graph.
// https://github.com/AzureAD/azure-activedirectory-identitymodel-extensions-for-dotnet/issues/609
export const DEFAULT_SCOPE_NAME = process.env.REACT_APP_DEFAULT_SCOPE || ".default";
export const getScopes = (appId: string) => {
  return {
    default: `${appId}/${DEFAULT_SCOPE_NAME}`,
  };
};
